import { Logo } from "@/shared/components/logo/Logo";
import { sidebarIsCollapsedAtom } from "@/shared/components/sidebar/Sidebar";
import { Button, Styles } from "@/shared/coralreef";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { percent, px, rem, viewHeight } from "csx";
import { Horizontal, Stretch, Vertical } from "gls";
import { useAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { style } from "typestyle";

export const WelcomePage = () => {
  const { t } = useTranslation();
  const [, setIsCollapsedLocalStorage] = useAtom(sidebarIsCollapsedAtom);

  return (
    <Vertical
      data-testid="welcome-page"
      width={percent(100)}
      padding={[viewHeight(20), 0, 0, 0]}
      horizontalAlign="center"
      className={style({
        color: Styles.Colours.textLight,
      })}
    >
      <Logo isCollapsed height={80} />
      <Divider />
      <Vertical
        horizontalAlign="center"
        spacing={rem(1)}
        className={style({
          color: Styles.Colours.textLight,
        })}
      >
        <div className="text-xl pb-5">{t("Welcome to Observe Tide!")}</div>
        <Horizontal spacing={rem(0.5)} verticalAlign="center">
          <span>{t("Use the ")}</span>
          <Button
            icon={faList}
            content="sidebar"
            appearance="hollow"
            onClick={() => setIsCollapsedLocalStorage(false)}
          />
          <span>{t("to select a page")}</span>
        </Horizontal>
      </Vertical>
    </Vertical>
  );
};

const Divider = () => (
  <Stretch
    className={style({
      height: px(1),
      background: Styles.Colours.textDisabled,
    })}
  />
);
